import React, { useEffect, useState } from 'react';
import { ImageOverlay } from 'react-leaflet';

const ImageOverlayLayer = ({ configUrl }) => {
    const [overlays, setOverlays] = useState([]);

    useEffect(() => {
        if (!configUrl) return;
        fetch(configUrl)
            .then(res => res.ok ? res.json() : [])
            .then(data => setOverlays(Array.isArray(data) ? data : []))
            .catch(err => console.error('Failed to load overlays config', err));
    }, [configUrl]);

    return (
        <>
            {overlays
                .filter(o => o.enabled && o.url && Array.isArray(o.bounds) && o.bounds.length === 2)
                .map(o => (
                    <ImageOverlay
                        key={o.id}
                        url={o.url}
                        bounds={o.bounds}
                        opacity={o.opacity ?? 0.75}
                        zIndex={200}
                    />
                ))
            }
        </>
    );
};

export default ImageOverlayLayer;
